import { Session } from '@ais-ui/auth';

export const checkSessionValid = async (
  session: Session,
  sessionUuid: string,
  userName: string,
): Promise<boolean> => {
  const response = await session.request('checkSessionValid', {
    sessionUuid,
    userName,
  });

  return response;
};

/**
 * Check if session is valid with a timeout.
 * Used for graceful error handling - validates session before logging out.
 */
export const checkSessionValidWithTimeout = async (
  session: Session,
  sessionUuid: string,
  userName: string,
  timeoutMs = 8000,
): Promise<{ valid: boolean; timedOut: boolean; error?: string }> => {
  try {
    const timeoutPromise = new Promise<never>((_, reject) => {
      setTimeout(
        () => reject(new Error('Session validation timeout')),
        timeoutMs,
      );
    });

    const validationPromise = checkSessionValid(session, sessionUuid, userName);

    const isValid = await Promise.race([validationPromise, timeoutPromise]);

    return { valid: isValid, timedOut: false };
  } catch (error) {
    if (
      error instanceof Error &&
      error.message === 'Session validation timeout'
    ) {
      return { valid: false, timedOut: true };
    }
    return {
      valid: false,
      timedOut: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};
